module.exports = __webpack_public_path__ + "static/img/images-icon.1c08d8b.svg";